import Handlebars from "utilities/vendor/handlebars/4.0.5/js/handlebars";
import hbs from "utilities/vendor/handlebars/4.0.5/js/handlebars";





'use strict';





var helpers = {



    ada: function(options) {
        return new Handlebars.SafeString("<span class='ada-hidden' data-version='2.0.0'>" + options.fn(this) + '</span>');
    },





    debug: function(logName) {
        var output = [],
            logName = (typeof logName !== 'undefined') ? 'Sparta Debug: ' + logName.toString() : '';

        output.push('<script>');
        output.push('console.group("' + logName + '");');
        output.push('console.group(' + JSON.stringify(this) + ');');
        output.push('console.groupEnd();');
        output.push('console.groupEnd();');
        output.push('</script>');

        return new Handlebars.SafeString(output.join(''));
    },





    debug_print: function(logName) {
        var output = [],
            debugStyles = {},
            logName = (typeof logName !== 'undefined') ? 'Sparta Debug: ' + logName.toString() : '';

        debugStyles.wrapper = 'position:relative; border:5px solid #333; padding:18px 10px 10px; margin: 5px 0;';
        debugStyles.header = 'position: absolute; top: 0; left: 0; width: 100%; height: 18px; font-size: 11px; background-color: #333; color: #fff; padding: 0; margin: 0;';

        output.push('<div class="spa-debug" data-debug="' + logName + '" style="' + debugStyles.wrapper + '">');
        output.push('<pre><h3 style="' + debugStyles.header + '">' + logName + '</h3>');
        output.push(JSON.stringify(this, 0, 2));
        output.push('</pre></div>');

        return new Handlebars.SafeString(output.join(''));
    },

    abbr: function abbrHelper(a) {
      const abbr = a;
      if (!abbr) return '';

      const value = abbr.value;
      delete abbr.value;
      let attr = '';

      const attrTemplate = (n, v) => `${n}="${v}"`;
      const abbrTemplate = (attributes, text) => `<abbr ${attributes}>${text}</abbr>`;

      for (const key in abbr) attr += attrTemplate(key, abbr[key]); 

      return abbrTemplate(attr, value);
    },


    link: function(link) {


        if (!link) {
            return '';
        }

        link.CLASS = link.CLASS || '';

        var windowOptions,
            layerClasses = {
                'layer': 'spa-ui-layer-link spa-fn',
                'popup': 'spa-fn spa-boa-window'
            },
            showAdaLayer = false;


        if (link.button) {

            link.CLASS += ' spa-btn';

            var button, buttonsConfig, buttonSizeClasses, buttonSkinClasses, buttonExpandClasses;

            button = link.button;

            buttonsConfig = {
                "sizes": {
                    "default": "spa-btn--small",
                    "small": "spa-btn--small",
                    "medium": "spa-btn--medium",
                    "large": "spa-btn--large",
                    "engagement": "spa-btn--engagement"
                },
                "skins": {
                    "default": "spa-btn--primary",
                    "primary": "spa-btn--primary",
                    "secondary": "spa-btn--secondary",
                    "reverse": "spa-btn--reverse",
                    "disabled": "spa-btn--disabled"
                },
                "expand": {
                    "small": "spa-btn--expand-on-small",
                    "medium": "spa-btn--expand-on-medium"
                }
            };



            if ((button.width || button.height) && button.size) {
                console.log('You may not set the button size with width and/or height. Choose one.');
            }



            if (button.skin) {
                link.CLASS += ' ' + buttonsConfig.skins[button.skin];
            }


            if (button.expand) {
                var buttonExpandKeys = Object.keys(buttonsConfig.expand);


                if (buttonExpandKeys.indexOf(button.expand) === -1) {
                    console.log('Button expand property may only be set as ' + buttonExpandKeys.join(', ') + '.');
                }


                link.CLASS += ' ' + buttonsConfig.expand[button.expand];
            }


            if (button.block) {
                link.CLASS += ' spa-btn--block';
            }


            if (button.size) {
                var buttonSizeKeys = Object.keys(buttonsConfig.sizes);


                if (!buttonsConfig.sizes[button.size]) {
                    console.log('Button size property may only be set as ' + buttonSizeKeys.join(', ') + '.');
                }


                link.CLASS += ' ' + buttonsConfig.sizes[button.size];
            } else {
                link.CLASS += ' ' + buttonsConfig.sizes.default;
            }
        }


        if (link.guillemet) {
            var guillemet = link.guillemet;

            link.CLASS += ' spa-guillemet';

            if (guillemet === 'left') {
                link.CLASS += ' spa-guillemet--left';
            }
        }


        if (link.actionType) {

            if (link.actionType.options) {
                windowOptions = link.actionType.options;
                link.OPTIONS = JSON.stringify(link.actionType.options);
            }


            if (link.actionType.type === 'layer') {
                showAdaLayer = true;
                link.REL = link.actionType.options.rel;
                link.CLASS += ' ' + layerClasses[link.actionType.type];

                if (link.actionType.options && link.actionType.options.interstitalType) {

                    link.CLASS += ' spa-ui-layer-interstitial';
                } else if(link.actionType.options && link.actionType.options.layerType) {

                    link.CLASS += ' spa-ui-layer-tooltip-link';
                } else {





                }
            }


            if (link.actionType.type === 'popup') {


                if ((windowOptions.width || windowOptions.height) && windowOptions.size) {
                    console.log(util.format('You may not set the popup size with width and/or height. Choose one.'));
                }


                link.CLASS += ' ' + layerClasses[link.actionType.type];
            }
        }


        if (link.CLASS.length) {
            link.CLASS = link.CLASS.replace(/^\s+|\s+$/g, '');
        }

        var output = "<a id='" + link.ID + "' href='" + (link.URL || "javascript:void(0);") + "'" +
                     (link.DATA_URL ? " data-href='" + link.DATA_URL + "'" : '') +
                     (link.CLASS ? " class='" + link.CLASS + "'" : '') +
                     (link.REL ? " rel='" + link.REL + "'" : "") +
                     (link.OPTIONS ? " data-options='" + Handlebars.Utils.escapeExpression(link.OPTIONS) + "'" : "") +
                     ((link.TARGET) ? " target='" + link.TARGET + "'" : "") +
                     (link.ROLE ? " role='" + link.ROLE + "'" : "") +
                     (link.bactmln ? " data-bactmln='" + link.bactmln + "'" : "") +
                     (link.tabIndex ? " tabindex='" + link.tabIndex + "'" : '') + ">" +
                     link.content +
                     (showAdaLayer ? "<span class='spa-ada-text ada-hidden'>&nbsp;layer</span>" : "") +
                     "</a>";

        return new Handlebars.SafeString(output);
    },

    layerContent: function(data, options) {
        var output = [
            '<div id="' + data.id + '" class="hide" data-options="' + Handlebars.Utils.escapeExpression(JSON.stringify(data.options)) + '">',
            '    <h3 id="' + data.id + '_title" data-font="cnx-regular">' + data.title + '</h3>',
            '    <div class="content">' + options.fn(this) + '</div>',
            '</div>'
        ].join('');

        return new Handlebars.SafeString(output);
    },

    spriteRules: function(o) {
        var output = "",
            writeRule = function(exp) {
                var css = "";

                switch (exp.experience) {
                    case "hires":
                        css += "html.mq-hires ";
                        break;
                    case "fallback":
                        css += "html.lt-ie9 ";
                        break;
                }
                if (exp.context != "default") css += "." + exp.context + " ";

                css += ".sprite .spr {\n\tbackground-image: url( " + exp.image + ");\n";
                if (exp.width && exp.height) {
                    css += "\tbackground-size: " + exp.width + " " + exp.height + ";\n"
                }
                css += "}\n\n";

                return css;
            };

        for (var context in o) {
            for (var experience in o[context]) {
                o[context][experience].context = context;
                o[context][experience].experience = experience;

                output += writeRule(o[context][experience]);
            }
        }

        return output;
    },

    writeBackgroundImage: function() {
        var args = Array.prototype.slice.call(arguments),
            breakpoints = [],
            output = "",

            writeBreakpoint = function(args, breakpoint) {
                var selector = args[0],
                    lowres = [],
                    hires = [],
                    position = [],
                    size = [],

                    mq = "",
                    css = "",

                    addAttribute = function(item, marker, list) {
                        if (typeof item === "undefined" || typeof item[marker] === "undefined") {
                            return list;
                        }

                        switch (typeof item[marker]) {
                            case "string":
                                list.push(item[marker]);
                                break;

                            case "object":
                                var tmp = [];
                                for (var i in item[marker]) {
                                    if (i == "width" || i == "height") {
                                        addAttribute(item[marker], i, tmp);
                                    }
                                }
                                list.push(tmp.join(" "));
                                break;
                        }

                        return list;
                    },

                    writeRule = function(attribute, selector, values, filter) {
                        var value = values.join(', ');
                        if (attribute === "background-image") {
                            value = 'url(' + values.join('), url(') + ')';
                        }

                        return (values.length > 0) ? (filter ? filter + ' ' : '') + selector + ' { ' + attribute + ': ' + value + '; }\n' : '';
                    };

                for (var i = 1; i < args.length - 1; i++) {
                    try {
                        var b = args[i][breakpoint];

                        lowres = addAttribute(b, "lowres", lowres);
                        hires = addAttribute(b, "hires", hires);
                        if (lowres.length > hires.length) {
                            hires.push(lowres[lowres.length - 1]);
                        }

                        size = addAttribute(b, "size", size);
                        position = addAttribute(b, "position", position);

                    } catch (err) {}
                }

                mq = (breakpoint === "default") ? "" : "html.mq-" + breakpoint;

                css += writeRule('background-image', selector, lowres, mq);
                css += writeRule('background-image', selector, hires, 'html.mq-hires' + mq.replace('html', ''));
                css += writeRule('background-size', selector, size, mq);
                css += writeRule('background-position', selector, position, mq);





                return css;
            };





        for (var i = 1; i < args.length - 1; i++) {
            for (var breakpoint in args[i]) {
                if (breakpoints.indexOf(breakpoint) === -1) {
                    breakpoints.push(breakpoint);
                }
            }
        }



        for (var b = 0; b < breakpoints.length; b++) {
            output += writeBreakpoint(args, breakpoints[b]);
        }

        return new Handlebars.SafeString(output);
    },

    writeDynamicId: function(type, base, output) {
        var id = "",
            content = [],
            badCharacters = ["&amp;", "[^A-Za-z0-9]"],
            cleanCharacters = function(str) {
                var replaceThese = new RegExp(badCharacters.join('|'), 'g');
                str = str.replace(replaceThese, '-');

                str = str.split('-').filter(function(n) {
                    return n != ''
                }).join('-');
                str = str.replace(/^-|-$/g, '');
                return str;
            },
            writeAttribute = function(id) {
                return ' id="' + id + '"';
            };

        if (!!this.id && !!base) {
            type = "id";
        }

        switch (type) {
            case "id":
                content.push(this.id);
                break;

            case "simple":
                if (!!this.text) {
                    content.push(this.text);
                }
                break;

            case "faq":
                if (!!this.question) {
                    content.push(this.question);
                }
                break;

            case "guide":
                if (!!this.heading) {
                    content.push(this.heading);
                }
                if (!!this.subHeading) {
                    content.push(this.subHeading);
                }
                break;

            case "map":
                if (!!this.meta.type) {
                    content.push(this.meta.type);
                }
                if (!!this.location.street1) {
                    content.push(this.location.street1);
                }
                if (!!this.location.street2) {
                    content.push(this.location.street2);
                }
                if (!!this.location.postal) {
                    content.push(this.location.postal);
                }
                break;
        }

        if (content.length > 0) {
            id = content.join('-').toLowerCase();
            id = cleanCharacters(id);
            id = ((!!base && base.length > 0 && id.indexOf(base) !== 0) ? base + "-" : "") + id;

            id = (output !== "bare") ? writeAttribute(id) : id;
        }

        return id;
    },

    spriteAdd: function(value, addition) {
        if (typeof(value) != "undefined") {
            return (parseInt(value.replace('px', "")) + addition) + "px";
        } else {
            return value
        };
    },

    spriteSubtract: function(value, substract) {
        if (typeof(value) != "undefined") {
            return (parseInt(value.replace('px', "")) - substract) + "px";
        } else {
            return value
        };
    },




    incrementValue: function(value) {
        if (typeof(value) != "undefined") {
            return (parseInt(value) + 1);
        } else {
            return 0;
        };
    },






    footnote: function(target) {
        var output = '<span class="spa-footnote-ref" data-footnote-ref="'+ target +'"></span>';
        return new Handlebars.SafeString(output);
    }


};


class helpersSparta {
  static register(Handlebars) {

    for (var helper in helpers) {
      if (helpers.hasOwnProperty(helper)) {
        Handlebars.registerHelper(helper, helpers[helper]);
      }
    }
  }

}

module.exports = helpersSparta;
module.exports.helpers = helpers;
